/*
 * fn: isPartnerable
 *
 * Checks whether two cards can be commanders together
 *
 */
import { type CardIdType, type CardMapType, type CardType } from '@/defs/card'
import { slugify } from '@/utils/commonUtil'

import { parseCardId } from './parseCardId'

type Props = {
  cardId: CardIdType
  cardMap: CardMapType
  partnerCardId: CardIdType
}

const isNamedPartner = (card: CardType, otherCardId: CardIdType) =>
  !!card.partnersWith && slugify(card.partnersWith) === parseCardId(otherCardId).slug

export const isPartnerable = ({ cardId, cardMap, partnerCardId }: Props) => {
  const a = cardMap[cardId]
  const b = cardMap[partnerCardId]
  if (!a || !b) return false

  if (isNamedPartner(a, partnerCardId) || isNamedPartner(b, cardId)) return true
  if (a.isDoctor && b.isDoctorsCompanion) return true
  if (a.isDoctorsCompanion && b.isDoctor) return true
  if (a.isBackground && b.isBackgroundChooser) return true
  if (a.isBackgroundChooser && b.isBackground) return true
  return !!a.partnerVariant && a.partnerVariant === b.partnerVariant
}
